export { CbDataTableOptions, CbDataTableColumnType, CbDataTableColumn, CbPagination, CbSort } from './cb-data-table-options';
export { CbDataTableModule } from './cb-data-table.module';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/cb-data-table/index.ts